// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileInput_fileInputLabel__F\\+W9z {
  display: inline-block;
  position: relative;
}

.FileInput_fileInputLabel__F\\+W9z input[type="file"] {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
}

.FileInput_fileInputButton__dFJLq {
  display: inline-block;
  background-color: #3f51b5;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.FileInput_fileInputButton__dFJLq:hover {
  background-color: #2c387e;
}
`, "",{"version":3,"sources":["webpack://./src/components/FileResourceList/FileInput/FileInput.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".fileInputLabel {\n  display: inline-block;\n  position: relative;\n}\n\n.fileInputLabel input[type=\"file\"] {\n  position: absolute;\n  opacity: 0;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  cursor: pointer;\n}\n\n.fileInputButton {\n  display: inline-block;\n  background-color: #3f51b5;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 10px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.fileInputButton:hover {\n  background-color: #2c387e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileInputLabel": `FileInput_fileInputLabel__F+W9z`,
	"fileInputButton": `FileInput_fileInputButton__dFJLq`
};
export default ___CSS_LOADER_EXPORT___;
